// extracted by mini-css-extract-plugin
export default {"root":"_2JN-2"};